import { render } from "./AboutFilmstroModal.vue?vue&type=template&id=e7022c12"
import script from "./AboutFilmstroModal.vue?vue&type=script&lang=js"
export * from "./AboutFilmstroModal.vue?vue&type=script&lang=js"

import "./AboutFilmstroModal.vue?vue&type=style&index=0&id=e7022c12&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__